import { WidgetConfig } from '../../components/elements/Draggable';

export const dashboardWidgetExecutive: WidgetConfig[] = [
  {
    chartType: 'bar',
    display: true,
    posisi: 1,
    title: 'Training Plan vs Training Completion',
    typeDataChart: 'TCTP'
  },
  {
    chartType: 'line',
    display: true,
    posisi: 2,
    title: 'Completion Rate Program',
    typeDataChart: 'CRP'
  },
  {
    chartType: 'bar',
    display: true,
    posisi: 3,
    title: 'Training Budget Realization',
    typeDataChart: 'TBR'
  },

  {
    chartType: 'bar',
    display: true,
    posisi: 7,
    title: 'Learning Engagement',
    typeDataChart: 'LE'
  },
  {
    chartType: 'bar',
    display: true,
    posisi: 8,
    title: 'Satisfactory Report',
    typeDataChart: 'SR'
  },
  {
    chartType: 'bar',
    display: true,
    posisi: 9,
    title: 'Knowledge Improvement',
    typeDataChart: 'KI'
  }
];
